import React from 'react';
import {
  Typography,
  Badge,
  Row as GridRow,
  Col,
} from 'design-system';
import { StarIcon } from '../../../design-system/components/Icons';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

export default function BadgeShowcase() {
  return (
    <>
        {/* Badge */}
        <GridRow>
          <Col xs={12}>
            <div className="design-system-section">
              <Typography variant="h1" className="section-title mb-4">
                Badge
              </Typography>
              <Separator className="mb-5" />
              <div className="d-flex flex-column" style={{ gap: 24 }}>
                <Typography variant="h3">Subtle · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="positive" size="sm">
                    Label
                  </Badge>
                  <Badge variant="positive" size="md">
                    Label
                  </Badge>
                  <Badge variant="positive" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Intense · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="positive" emphasis="intense" size="sm">
                    Label
                  </Badge>
                  <Badge variant="positive" emphasis="intense" size="md">
                    Label
                  </Badge>
                  <Badge variant="positive" emphasis="intense" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Negative Subtle · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="negative" size="sm">
                    Label
                  </Badge>
                  <Badge variant="negative" size="md">
                    Label
                  </Badge>
                  <Badge variant="negative" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Negative Intense · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="negative" emphasis="intense" size="sm">
                    Label
                  </Badge>
                  <Badge variant="negative" emphasis="intense" size="md">
                    Label
                  </Badge>
                  <Badge variant="negative" emphasis="intense" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Notice Subtle · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="notice" size="sm">
                    Label
                  </Badge>
                  <Badge variant="notice" size="md">
                    Label
                  </Badge>
                  <Badge variant="notice" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Notice Intense · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="notice" emphasis="intense" size="sm">
                    Label
                  </Badge>
                  <Badge variant="notice" emphasis="intense" size="md">
                    Label
                  </Badge>
                  <Badge variant="notice" emphasis="intense" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Information Subtle · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="information" size="sm">
                    Label
                  </Badge>
                  <Badge variant="information" size="md">
                    Label
                  </Badge>
                  <Badge variant="information" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Information Intense · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="information" emphasis="intense" size="sm">
                    Label
                  </Badge>
                  <Badge variant="information" emphasis="intense" size="md">
                    Label
                  </Badge>
                  <Badge variant="information" emphasis="intense" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Waiting Subtle · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="waiting" size="sm">
                    Label
                  </Badge>
                  <Badge variant="waiting" size="md">
                    Label
                  </Badge>
                  <Badge variant="waiting" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Waiting Intense · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="waiting" emphasis="intense" size="sm">
                    Label
                  </Badge>
                  <Badge variant="waiting" emphasis="intense" size="md">
                    Label
                  </Badge>
                  <Badge variant="waiting" emphasis="intense" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Primary Subtle · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="primary" size="sm">
                    Label
                  </Badge>
                  <Badge variant="primary" size="md">
                    Label
                  </Badge>
                  <Badge variant="primary" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Primary Intense · sm / md / lg</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="primary" emphasis="intense" size="sm">
                    Label
                  </Badge>
                  <Badge variant="primary" emphasis="intense" size="md">
                    Label
                  </Badge>
                  <Badge variant="primary" emphasis="intense" size="lg">
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Intents (md, subtle)</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="positive">Positive</Badge>
                  <Badge variant="negative">Negative</Badge>
                  <Badge variant="notice">Notice</Badge>
                  <Badge variant="information">Information</Badge>
                  <Badge variant="waiting">Waiting</Badge>
                  <Badge variant="primary">Primary</Badge>
                </div>
                <Typography variant="h3">Bordered</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="information" bordered icon={<StarIcon size={12} filled aria-hidden />}>
                    Enhanced Tier
                  </Badge>
                  <Badge variant="information" size="md">
                    Enhanced Tier
                  </Badge>
                  <Badge variant="positive" bordered>
                    Positive
                  </Badge>
                  <Badge variant="primary" bordered>
                    Primary
                  </Badge>
                  <Badge variant="waiting" bordered>
                    Waiting
                  </Badge>
                  <Badge variant="waiting" bordered transparent>
                    Transparent
                  </Badge>
                </div>
                <Typography variant="h3">Optional icon</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="information" icon={<i className="simple-icon-check" aria-hidden />}>
                    Label
                  </Badge>
                  <Badge
                    variant="positive"
                    emphasis="intense"
                    size="lg"
                    icon={<i className="simple-icon-check" aria-hidden />}
                  >
                    Label
                  </Badge>
                </div>
                <Typography variant="h3">Dot · rounded · removable</Typography>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: 10 }}>
                  <Badge variant="primary" dot>
                    &nbsp;
                  </Badge>
                  <Badge variant="negative" type="rounded" size="sm">
                    Rounded
                  </Badge>
                  <Badge variant="primary" removable onDismiss={() => {}}>
                    Removable
                  </Badge>
                </div>
              </div>
            </div>
          </Col>
        </GridRow>
    </>
  );
}